import PropTypes from 'prop-types';

const room = PropTypes.shape({
  _id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  quantity: PropTypes.number.isRequired,
});

const booking = PropTypes.shape({
  _id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  image: PropTypes.string.isRequired,
  adults: PropTypes.number.isRequired,
  amount: PropTypes.number.isRequired,
  checkin: PropTypes.string.isRequired,
  checkout: PropTypes.string.isRequired,
  childrens: PropTypes.number.isRequired,
  bookeseCode: PropTypes.string.isRequired,
  rooms: PropTypes.arrayOf(room).isRequired,
});

const bookings = PropTypes.arrayOf(booking);

const BookingPropTypes = {
  room,
  booking,
  bookings,
};

export default BookingPropTypes;
